// Polyfill for browsers that don't support the Invoker Commands API (e.g. iOS Safari)
if (!('command' in document.createElement('button'))) {
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[commandfor]');
    if (!button) return;

    const targetId = button.getAttribute('commandfor');
    const command = button.getAttribute('command');
    const target = document.getElementById(targetId);
    if (!target) return;

    if (command === 'show-modal' && target.tagName === 'DIALOG') {
      target.showModal();
    }
    else if (command === 'close') {
      if (target.tagName === 'DIALOG') target.close();
      else target.hidePopover?.();
    }
    else if (command === 'toggle-popover') {
      target.togglePopover?.();
    }
    else if (command === 'show-popover') {
      target.showPopover?.();
    }
    else if (command === 'hide-popover') {
      target.hidePopover?.();
    }
  });
}
class Dialog {
  static scrollLocked = false;

  // Toggle events coalesce on rapid open/close, so derive the lock state from the DOM instead of counting events.
  static syncScrollLock() {
    const anyModalOpen = !!document.querySelector('dialog:modal');
    if (anyModalOpen && !Dialog.scrollLocked) {
      scrollLock.lock();
      Dialog.scrollLocked = true;
    }
    else if (!anyModalOpen && Dialog.scrollLocked) {
      scrollLock.unlock();
      Dialog.scrollLocked = false;
    }
  }

  constructor(dialog) {
    this.dialog = dialog;
    if (!this.dialog) return;

    this.dialog.addEventListener('toggle', (event) => {
      Dialog.syncScrollLock();

      if (event.newState === 'open') {
        // Focus the marked element on devices with a mouse only, so touch devices don't open the on-screen keyboard.
        const focusTarget = this.dialog.querySelector('[data-autofocus-desktop]');
        if (focusTarget && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          focusTarget.focus();
        }

        window.dispatchEvent(new CustomEvent('dialog:open', { detail: this.dialog,
          bubbles: true }));
      }
    });

    // Light dismiss fallback for browsers without `closedby` support (e.g. iOS Safari).
    if (!('closedBy' in HTMLDialogElement.prototype) && this.dialog.getAttribute('closedby') === 'any') {
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        const insideDialog = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!insideDialog) this.dialog.close();
      });
    }

    const form = this.dialog.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => this.dialog.close());
    }
  }

  static prefetch(target) {
    const variantSelector = target.querySelector('variant-selector');
    if (!variantSelector || variantSelector._prefetchedHTML) return;

    const options = JSON.parse(variantSelector.dataset.options);
    const currentVariantId = variantSelector.closest('product-form-component')?.querySelector('input[name="id"]')?.value;
    const url = `${options.url}?variant=${currentVariantId}&section_id=theme-quick-shop`;
    variantSelector._prefetchedHTML = fetch(url).then(response => response.text());
  }

  static loadQuickShop(target) {
    const variantSelector = target.querySelector('variant-selector');
    return variantSelector?.handleVariantChange(null, true) ?? Promise.resolve();
  }
}

window.Dialog = Dialog;

window.initDialogs = function (container = document) {
  container = container ?? document;
  container.querySelectorAll('dialog:not([data-dialog-initialized])').forEach((dialog) => {
    dialog.setAttribute('data-dialog-initialized', '');
    new Dialog(dialog);
  });

  container.querySelectorAll('[data-dialog-quickshop-trigger]:not([data-dialog-trigger-initialized])').forEach((trigger) => {
    trigger.setAttribute('data-dialog-trigger-initialized', '');
    trigger.addEventListener('pointerenter', () => {
      const targetId = trigger.getAttribute('commandfor');
      const targetDialog = targetId ? document.getElementById(targetId) : null;
      if (targetDialog) Dialog.prefetch(targetDialog);
    }, { once: true });

    trigger.addEventListener('click', () => {
      const targetId = trigger.getAttribute('commandfor');
      const targetDialog = targetId ? document.getElementById(targetId) : null;
      if (!targetDialog) return;
      Dialog.loadQuickShop(targetDialog).then(() => {
        if (!targetDialog.open) targetDialog.showModal();
      });
    });
  });
};

window.initDialogs();

window.addEventListener('window:load-more', (event) => {
  initDialogs(event.detail.container);
});

window.addEventListener('shopify:section:load', (event) => {
  const sectionId = event.detail?.sectionId;
  if (!sectionId) return;
  const sectionEl = document.getElementById(`shopify-section-${sectionId}`);
  if (sectionEl) {
    initDialogs(sectionEl);
  }
});
